export enum DateCategoryPosition {
    Top,
    Bottom,
}
